<section class="main-wrap inner-views dashboard-wrap new-sidebar" [ngClass]="{ 'menu-open in': !toggleClass }">
  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
        <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
      </button>

      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>

    <div class="container-wrap no-filters">

      <div class="heading-container sidebar-container" id="menu">

        <div class="row">
          <div class="col">

            <app-logo></app-logo>

            <div class="button-box">
              <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
                <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
              </button>
            </div>

            <app-header></app-header>
          </div>
        </div>
      </div>

        <div class="content-container profile-container page-content faqs">
            <div class="row">
                <div class="col-md-12 dash-title">
                    <h1>
                        FAQ’s
                    </h1>
                </div>
                <div class="clearfix"></div>

                <div class="col-md-12 content-col profile-data">
                    <div class="accordion" id="accordion-profile">
                        <div class="card">
                            <div class="card-header" id="profile-username">
                                <h2 class="mb-0">
                                    <button aria-controls="profileUser" aria-expanded="false"
                                            class="btn btn-link btn-block text-left collapsed" data-target="#profileUser" data-toggle="collapse"
                                            type="button">
                                        Where do I see my benefits?
                                    </button>
                                </h2>
                            </div>
                            <div aria-labelledby="profile-username" class="collapse" data-parent="#accordion-profile"
                                 id="profileUser">
                                <div class="card-body">
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="contact-info">
                                <h2 class="mb-0">
                                    <button aria-controls="contactInfo" aria-expanded="false"
                                            class="btn btn-link btn-block text-left collapsed" data-target="#contactInfo" data-toggle="collapse"
                                            type="button">
                                        Lorem ipsum dolor sit amet consectetur adipiscing elit?
                                    </button>
                                </h2>
                            </div>
                            <div aria-labelledby="contact-info" class="collapse" data-parent="#accordion-profile"
                                 id="contactInfo">
                                <div class="card-body">
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="shipping-address">
                                <h2 class="mb-0">
                                    <button aria-controls="shippingAddress" aria-expanded="false"
                                            class="btn btn-link btn-block text-left collapsed" data-target="#shippingAddress" data-toggle="collapse"
                                            type="button">
                                        Lorem ipsum dolor sit amet consectetur adipiscing elit?
                                    </button>
                                </h2>
                            </div>
                            <div aria-labelledby="shipping-address" class="collapse" data-parent="#accordion-profile"
                                 id="shippingAddress">
                                <div class="card-body">
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>
    </div>

</section>
